import { TableRow, TableCell, Box, Typography } from '@mui/material';
import InboxOutlined from '@mui/icons-material/InboxOutlined';
import { ReactNode } from 'react';

interface EmptyTablePlaceholderProps {
    colSpan: number;
    title: string;
    subtitle?: string;
    icon?: ReactNode;
}

const EmptyTablePlaceholder = ({
    colSpan,
    title,
    subtitle,
    icon,
}: EmptyTablePlaceholderProps) => {
    return (
        <TableRow>
            <TableCell colSpan={colSpan} sx={{ py: 5 }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'text.secondary',
                        gap: 1,
                    }}
                >
                    {icon ?? <InboxOutlined fontSize="large" />}
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        {title}
                    </Typography>
                    {subtitle && (
                        <Typography variant="body2" color="text.secondary">
                            {subtitle}
                        </Typography>
                    )}
                </Box>
            </TableCell>
        </TableRow>
    );
};

export default EmptyTablePlaceholder;
